import { render, staticRenderFns } from "./KidsAppReviewRequest.vue?vue&type=template&id=85954868&scoped=true"
import script from "./KidsAppReviewRequest.vue?vue&type=script&lang=js"
export * from "./KidsAppReviewRequest.vue?vue&type=script&lang=js"
import style0 from "./KidsAppReviewRequest.vue?vue&type=style&index=0&id=85954868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85954868",
  null
  
)

export default component.exports